<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs11 class="offset-half">
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-folder-star-outline</v-icon
              >
            </v-card>
            <div class="usuario">CERRADOS</div>
            <v-spacer></v-spacer>
            <div class="filter-container">
              <!-- Filtro para cambiar vista -->
              <v-select
                v-if="!$vuetify.breakpoint.xs"
                v-model="selectedFilter"
                :items="filterOptions"
                item-text="text"
                item-value="value"
                label="Cambiar vista"
                outlined
                dense
                style="max-width: 150px; font-size: 13.5px"
                @change="changeFilter"
              ></v-select>
              <!-- Solo icono para pantallas pequeñas -->
              <v-menu
                v-if="$vuetify.breakpoint.xs"
                v-model="showFilterMenu"
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="filter-icon-btn">
                    <v-icon>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="option in filterOptions"
                    :key="option.value"
                    @click="selectFilterOption(option.value)"
                  >
                    <v-list-item-title>{{ option.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <!-- Botón de actualizar manual -->
            <!-- <v-btn color="#1D3C7F" @click="buscarIncidentes" class="ml-5" style="color: white; font-weight: bold;">
              <v-icon left>mdi-refresh</v-icon>
              Actualizar
            </v-btn> -->
          </v-toolbar>
          <v-container fluid class="mt-5">
            <v-row>
              <v-col cols="12" sm="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dates"
                      label="Selecciona el rango de fechas para consultar tickets "
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es-es"
                    range
                    v-model="dates"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="consultarIncidentes(dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  :loading="loading"
                  color="blue darken-4"
                  tile
                  dark
                  class="mt-1"
                  @click="buscarIncidentes()"
                >
                  <v-icon> mdi-magnify </v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <br />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar caso cerrado"
            class="text-field"
            single-line
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="casos"
            :search="search"
            style="border: 2px solid #111c3d"
            class="elevation-3"
            must-sort
          >
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.semaforo`]="{ item }">
              <SemaforoTiempo
                :fecha-inicio="item.fecha_area"
                :dias="requerimientosInfo[item.cc_id_requerimiento]?.dias || 0"
                :horas="
                  requerimientosInfo[item.cc_id_requerimiento]?.horas || 0
                "
                :minutos="
                  requerimientosInfo[item.cc_id_requerimiento]?.minutos || 0
                "
                :id-caso="item.cc_id_caso"
              />
            </template>
            <template v-slot:[`item.cc_prioridad_requerimiento`]="{ item }">
              <div v-if="item.cc_prioridad_requerimiento === '3'">
                <v-chip outlined class="ma-2" :color="getColor(3)">
                  ALTA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '2'">
                <v-chip outlined class="ma-2" :color="getColor(2)">
                  MEDIA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '1'">
                <v-chip outlined class="ma-2" :color="getColor(1)">
                  BAJA
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                color="light-blue darken-4"
                class="mr-2"
                @click="verConversacion(item)"
              >
                mdi-wechat
              </v-icon>
              <v-icon
                color="light-green lighten-1"
                class="mr-2"
                @click="verObservacion(item)"
              >
                mdi-eye
              </v-icon>
              <v-icon
                v-if="item.cc_ruta !== ''"
                color="light-blue"
                class="mr-2"
                @click="verImagen(item)"
              >
                mdi-image
              </v-icon>
              <v-icon color="purple" class="mr-2" @click="verHistorial(item)">
                mdi-timeline-clock
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <!-- Dialog que permite visualizar la conversacion -->
          <v-dialog v-model="dialog2" max-width="500px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-message-bulleted</v-icon>
                  Conversación</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text>
                <div v-for="(chat, index) in chatItem" :key="index">
                  <v-card class="mt-3 mx-auto" width="550">
                    <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                      <p class="indigo--text text--darken-3">
                        <v-icon color="indigo darken-4" class="ml-5 mr-1"
                          >mdi-robot</v-icon
                        >{{ chat.user }}
                      </p>
                    </v-card-subtitle>
                    <v-card-subtitle v-else class="d-flex justify-end">
                      <p class="deep-purple--text text--accent-3">
                        <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                          >mdi-face</v-icon
                        >{{ chat.user }}
                      </p>
                    </v-card-subtitle>
                    <v-card-text v-if="chat.user == 'NOVA'" class="">
                      <p
                        class="grey--text text--darken-1 text-left chat-message"
                      >
                        {{ chat.message }}
                      </p>
                    </v-card-text>
                    <v-card-text v-else class="d-flex justify-end">
                      <p
                        class="grey--text text--darken-1 text-right chat-message"
                      >
                        {{ chat.message }}
                      </p>
                    </v-card-text>
                  </v-card>
                </div>
                <v-divider class="mt-5"></v-divider>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#1D3C7F"
                  dark
                  @click="verEvidencias(idCasoActual)"
                  class="mr-2"
                >
                  <v-icon left>mdi-image-multiple</v-icon>
                  VER EVIDENCIAS
                </v-btn>
                <v-btn color="#1D3C7F" dark @click="close2">CERRAR</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Dialog que permite ver las observaciones -->
          <v-dialog v-model="dialog3" max-width="500px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-message-bulleted</v-icon>
                  Observacion del caso</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text class="pa-5">
                <p style="font-size: 18px">
                  {{
                    observacion
                      ? observacion
                      : "No se ingreso una observación para este caso"
                  }}
                </p>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="close3">CERRAR</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Dialog que permite ver las evidencias (imágenes y documentos) -->
          <v-dialog
            v-model="dialog4"
            max-width="700px"
            max-height="600px"
            persistent
          >
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-image</v-icon>
                  Evidencias del Caso
                </span>
              </v-card-title>
              <v-card-text class="pa-5">
                <div v-if="cc_rutas.length === 0">
                  <v-alert type="info" outlined>
                    No hay evidencias disponibles para este caso.
                  </v-alert>
                </div>
                <v-row v-else>
                  <v-col
                    v-for="(ruta, idx) in cc_rutas"
                    :key="idx"
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <template v-if="isImageUrl(ruta)">
                      <v-img
                        :src="ruta"
                        alt="Imagen"
                        aspect-ratio="1"
                        class="grey lighten-2"
                        style="cursor: pointer"
                        @click="verImagenCompleta(ruta)"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#294697"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </template>
                    <template v-else>
                      <v-card
                        class="d-flex flex-column align-center justify-center pa-3"
                        style="cursor: pointer; aspect-ratio: 1; height: 100%"
                        @click="downloadFile(ruta)"
                      >
                        <v-icon size="80" color="grey darken-1"
                          >mdi-file-document-outline</v-icon
                        >
                        <div
                          class="mt-2 text-caption grey--text text--darken-1 text-center"
                          style="word-break: break-all"
                        >
                          {{ getFileName(ruta) }}
                        </div>
                      </v-card>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#294697" dark @click="close4">CERRAR</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- fin Dialog que permite ver las imagnes jempoder ----------------->

          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#294697"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#294697" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
          <CaseHistoryTimeline
            v-if="idCasoActual !== null"
            :caseId="idCasoActual"
            :visible.sync="dialogHistorial"
          />
          <!-- Modal para ver las evidencias del caso -->
          <v-dialog v-model="dialogEvidencias" max-width="900px">
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-image-multiple</v-icon>
                  Evidencias del caso #{{ idCasoActual }}
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <div v-if="cargandoEvidencias" class="text-center my-5">
                    <v-progress-circular
                      indeterminate
                      color="#294697"
                    ></v-progress-circular>
                    <p>Cargando evidencias...</p>
                  </div>
                  <div
                    v-else-if="
                      !Array.isArray(evidencias) || evidencias.length === 0
                    "
                    class="text-center my-5"
                  >
                    <v-alert type="info" outlined>
                      No hay evidencias disponibles para este caso.
                    </v-alert>
                  </div>
                  <v-row v-else>
                    <v-col
                      v-for="(evidencia, index) in evidencias"
                      :key="index"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-card outlined>
                        <template
                          v-if="isImageUrl(evidencia.cc_ruta_evidencia)"
                        >
                          <v-img
                            :src="evidencia.cc_ruta_evidencia"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            @click="
                              verImagenCompleta(evidencia.cc_ruta_evidencia)
                            "
                            style="cursor: pointer"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#294697"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </template>
                        <template v-else>
                          <v-card
                            class="d-flex flex-column align-center justify-center pa-3"
                            style="
                              cursor: pointer;
                              aspect-ratio: 1;
                              height: 100%;
                            "
                            @click="downloadFile(evidencia.cc_ruta_evidencia)"
                          >
                            <v-icon size="80" color="grey darken-1"
                              >mdi-file-document-outline</v-icon
                            >
                            <div
                              class="mt-2 text-caption grey--text text--darken-1 text-center"
                              style="word-break: break-all"
                            >
                              {{ getFileName(evidencia.cc_ruta_evidencia) }}
                            </div>
                          </v-card>
                        </template>
                        <v-card-text class="pa-2">
                          <small class="grey--text">{{
                            formatDate(evidencia.fecha_subida)
                          }}</small>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeEvidencias"
                  >CERRAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal para ver una imagen en pantalla completa -->
          <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
            <v-card flat>
              <v-toolbar dark color="#1D3C7F" flat>
                <v-btn icon dark @click="descargarImagen">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-toolbar-title>Evidencia</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogImagenCompleta = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text
                class="pa-0 d-flex justify-center align-center"
                style="height: calc(100vh - 64px); background-color: #000"
              >
                <img
                  :src="imagenSeleccionada"
                  style="max-height: 95vh; max-width: 95vw; object-fit: contain"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";
import CaseHistoryTimeline from "./CaseHistoryTimeline.vue";
export default {
  components: {
    CaseHistoryTimeline,
  },
  data() {
    return {
      // Propiedades para el filtro
      selectedFilter: "cerrados",
      showFilterMenu: false,
      filterOptions: [
        { text: "TICKETS", value: "tickets" },
        { text: "PENDIENTES", value: "pendientes" },
        { text: "ASIGNADOS", value: "asignados" },
        { text: "SUSPENDIDOS", value: "suspendidos" },
        { text: "CERRADOS", value: "cerrados" },
      ],
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      casos: [],
      chatItem: [],
      observacion: "",
      requerimientosInfo: {},
      dialogEvidencias: false,
      dialogImagenCompleta: false,
      evidencias: [],
      cargandoEvidencias: false,
      imagenSeleccionada: "",
      idCasoActual: null,

      ///////////////////////Rutas de archivos evidencias//////////////////
      cc_rutas: [], // array de rutas de archivos
      ///////////////////////rutas de archivos evidencias//////////////////
      dates: ["", ""],
      menu: false,
      idCaso: null,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      /////////////////////Dialogo Donde muestra imagenes
      dialog4: false,
      /////////////////////Dialogo Donde muestra imagenes
      dialogHistorial: false,
      idCasoActual: null,

      headers: [
        {
          text: "ACCIONES",
          value: "action",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "ID",
          value: "cc_id_caso",
          align: "center",
          class: "column",
        },
        {
          text: "IP",
          value: "ip",
          align: "center",
          class: "column",
        },
        {
          text: "NOMBRE PUNTO",
          value: "nombre_punto",
          align: "center",
          class: "column",
        },
        {
          text: "EMPRESA",
          value: "nombreEmpresa",
          align: "center",
          class: "column",
        },
        {
          text: "MUNICIPIO",
          value: "municipio",
          align: "center",
          class: "column",
        },
        {
          text: "PRIORIDAD",
          value: "cc_prioridad_requerimiento",
          align: "center",
          class: "column",
        },
        {
          text: "FECHA/HORA APERTURA",
          value: "fecha_inicio",
          align: "center",
          class: "column",
        },
        {
          text: "FECHA/HORA CIERRE",
          value: "fecha_cierre",
          align: "center",
          class: "column",
        },
        {
          text: "REQUERIMIENTO",
          value: "cc_nombre_requerimiento",
          align: "center",
          class: "column",
        },
      ],
      defaultItem: [],
      editedIndex: -1,
      editedItem: [],
      dialog2: false,
      dialog3: false,
      dialog4: false,
      fechaInicio: "",
      fechaActual: "",
      loading: false,
    };
  },
  created() {
    this.obtenerFechas();
    this.obtenerIncidentes(this.fechaInicio, this.fechaActual);
  },
  methods: {
    // Método para cambiar de vista
    changeFilter() {
      // Emitir evento para que el componente padre maneje la navegación
      this.$emit("change-view", this.selectedFilter);
    },
    selectFilterOption(value) {
      this.selectedFilter = value;
      this.showFilterMenu = false;
      this.$emit("change-view", value);
    },

    obtenerFechas() {
      const date = new Date();
      this.fechaInicio = new Date(date.getFullYear(), date.getMonth(), 1);
      this.fechaInicio = this.fechaInicio.toISOString().substr(0, 10);
      this.fechaActual = new Date().toISOString().substr(0, 10);
      this.dates = [this.fechaInicio, this.fechaActual];
    },
    // Metodo para obtener todos lo incidentes pendientes
    obtenerIncidentes(fechaInicial, fechaFinal) {
      axios
        .get(
          `${
            env.endpoint
          }callcenter/incidentescerrados?id=${localStorage.getItem(
            "id",
          )}&fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`,
        )
        .then((res) => {
          if (Array.isArray(res.data)) {
            res.data.sort((a, b) => {
              const fA = a.fecha_inicio || "";
              const fB = b.fecha_inicio || "";
              return fA.localeCompare(fB);
            });
          }
          this.casos = res.data;
        });
    },
    buscarIncidentes() {
      if (this.dates.length == 2) {
        this.loading = true;
        if (this.dates[0] > this.dates[1]) {
          let temp = this.dates[0];
          this.dates[0] = this.dates[1];
          this.dates[1] = temp;
        }
        axios
          .get(
            `${
              env.endpoint
            }callcenter/incidentescerrados?id=${localStorage.getItem(
              "id",
            )}&fechaInicial=${this.dates[0]}&fechaFinal=${this.dates[1]}`,
          )
          .then((res) => {
            if (Array.isArray(res.data)) {
              res.data.sort((a, b) => {
                const fA = a.fecha_inicio || "";
                const fB = b.fecha_inicio || "";
                return fA.localeCompare(fB);
              });
            }
            this.casos = res.data;
            this.loading = false;
          });
      } else {
        this.text =
          "Seleccione por favor dos fechas, de lo contrario no podra filtrar los resultados";
        this.snackbar = true;
      }
    },
    /**
     * Metodo para cerrar la modal de ver conversacion
     */
    close2() {
      this.dialog2 = false;
      setTimeout(() => {
        this.editedItem = this.defaultItem;
        this.editedIndex = -1;
      }, 300);
    },
    //////////////////////////boton para descargar imagen
    // descargarImagen() {
    //   // Lógica para descargar la imagen, por ejemplo, redireccionar a la ruta de la imagen
    //   window.open(this.cc_ruta, '_blank');
    // },
    /**
     * Metodo para cerrar la modal de observacion
     */
    close3() {
      this.dialog3 = false;
    },
    ////////////////// Metodo para cerrrar modal
    close4() {
      this.dialog4 = false;
    },

    /**
     * Metodo para mostrar la modal y enviar la conversacion
     */
    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      const data = JSON.parse(JSON.stringify(item));
      this.chatItem = data.conversacion;
      if (this.chatItem == null) {
        this.chatItem = [
          {
            user: "NOVA",
            message: "Lo sentimos, no se encuentra un chat para este caso.",
          },
        ];
      }
    },
    /**
     * Metodo para mostrar la modal que lleva la observacion
     */
    verObservacion(item) {
      this.dialog3 = true;
      this.observacion = item.observaciones;
    },

    verImagen(item) {
      this.dialog4 = true;
      // Si hay varias rutas separadas por coma, conviértelas en array
      if (item.cc_ruta && typeof item.cc_ruta === "string") {
        this.cc_rutas = item.cc_ruta
          .split(",")
          .map((r) => r.trim())
          .filter((r) => r);
      } else {
        this.cc_rutas = [];
      }
    },

    verHistorial(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorial = true;
    },

    consultarIncidentes(dates) {
      this.$refs.menu.save(dates);
    },
    getColor(tipo) {
      if (tipo === 1) {
        return "green";
      } else {
        if (tipo === 2) {
          return "orange";
        } else {
          return "red";
        }
      }
    },
    /**
     * Método para obtener y mostrar las evidencias de un caso
     */
    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];

      // enpoint para traer imagenes al modal chat
      axios
        .get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then((response) => {
          this.evidencias = response.data.evidencias;
          // console.log(response.data.evidencias);
        })
        .catch((error) => {
          console.error("Error al cargar evidencias:", error);
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },

    /**
     * Método para cerrar el modal de evidencias
     */
    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },

    /**
     * Método para ver una imagen en pantalla completa
     */
    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      if (this.dialogEvidencias) this.dialogEvidencias = false;
      if (this.dialog4) this.dialog4 = false;
      this.dialogImagenCompleta = true;
    },

    /**
     * Método para formatear la fecha de la evidencia
     */
    formatDate(dateString) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    },

    /**
     * Método para aumentar la imagen en pantalla completa
     */
    aumentarImagen() {
      this.imagenSeleccionada = this.cc_ruta;
      this.dialog4 = false;
      this.dialogImagenCompleta = true;
    },

    /**
     * Método para descargar la imagen seleccionada
     */
    descargarImagen() {
      const link = document.createElement("a");
      link.href = this.imagenSeleccionada;
      link.download = this.imagenSeleccionada.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    getFileName(url) {
      if (!url) return "Archivo";
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf("/") + 1);
      } catch (e) {
        // Fallback for relative paths or simple filenames
        const parts = url.split("/");
        return parts[parts.length - 1] || "Archivo";
      }
    },
    downloadFile(url) {
      // Si es PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, abre en nueva ventana
      const ext = url.split(".").pop().toLowerCase();
      const openInNewTab = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
      ].includes(ext);
      if (openInNewTab) {
        window.open(url, "_blank");
      } else {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.getFileName(url));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  },
};
</script>

<style scoped>
.text-field {
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.table {
  border-radius: 10px;
}

@media (min-width: 768px) {
  .table {
    margin: 10px;
  }
}

.column {
  font-weight: bold;
  background-color: #f2f2f2;
}

.nav {
  background-color: #111c3d;
  color: white;
  font-weight: bold;
}

.indigo--text {
  color: #3f51b5 !important;
}

.deep-purple--text {
  color: #673ab7 !important;
}

.grey--text {
  color: #757575 !important;
}

.ma-2 {
  margin: 0.5rem !important;
}

.pa-5 {
  padding: 3rem !important;
}

.elevation-3 {
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2) !important;
}

.v-input__control {
  min-height: 56px;
}

.v-card {
  border-radius: 10px;
}

.v-dialog {
  border-radius: 10px;
}

.v-btn {
  border-radius: 5px;
}

.chat-message {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 100%;
}

.filter-container {
  margin-left: auto;
  margin-right: 16px;
}

/* Responsive para dispositivos móviles */
@media (max-width: 768px) {
  .filter-container {
    margin-left: auto;
    margin-right: 8px;
  }
}

@media (max-width: 430px) {
  .filter-container {
    margin-left: auto;
    margin-right: 4px;
  }
}

/* Estilos para el botón de filtro en móvil */
.filter-icon-btn {
  color: #1d3c7f !important;
}

.filter-icon-btn:hover {
  background-color: rgba(29, 60, 127, 0.1) !important;
}

.offset-half {
  max-width: 98%;
  margin: 15px 3.5rem;
}

@media (max-width: 599px) {
  .offset-half {
    max-width: 98%;
    margin: 10px 3.5rem;
  }
}

/* Ajustar el responsive para el filtro */
@media (max-width: 599px) {
  .filter-container {
    margin-left: auto;
    margin-right: 4px;
  }
}

/* Estilos responsive solo para pantallas pequeñas */
@media (max-width: 960px) {
  .v-toolbar .icon {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .v-toolbar .icon .v-icon {
    transition: all 0.3s ease !important;
  }

  .v-toolbar .usuario {
    font-weight: bold !important;
    transition: all 0.3s ease !important;
    white-space: nowrap !important;
  }

  /* Asegurar altura correcta del toolbar */
  .v-toolbar {
    min-height: 64px !important;
    align-items: center !important;
  }

  .v-toolbar_content {
    align-items: center !important;
    min-height: 64px !important;
  }
}

/* Responsive para móvil */
@media (max-width: 599px) {
  .v-toolbar .icon {
    min-width: 40px !important;
    max-width: 40px !important;
    height: 40px !important;
  }

  .v-toolbar .icon .v-icon {
    font-size: 20px !important;
    margin-left: 8px !important;
    margin-top: 0 !important;
  }

  .v-toolbar .usuario {
    font-size: 14px !important;
    margin-left: 8px !important;
  }
}

/* Responsive para tablet */
@media (min-width: 600px) and (max-width: 960px) {
  .v-toolbar .icon {
    min-width: 50px !important;
    max-width: 50px !important;
    height: 50px !important;
  }

  .v-toolbar .icon .v-icon {
    font-size: 24px !important;
    margin-left: 15px !important;
    margin-top: 12px !important;
  }

  .v-toolbar .usuario {
    font-size: 16px !important;
    margin-left: 12px !important;
  }

  /* Ajustar el botón NOVA en tablet */
  .v-toolbar .v-btn {
    min-width: auto !important;
    padding: 0 12px !important;
    font-size: 12px !important;
  }
}

/* Estilos para el botón NOVA en móvil */
@media (max-width: 599px) {
  .v-toolbar .v-btn {
    min-width: auto !important;
    padding: 0 8px !important;
    font-size: 11px !important;
    height: 40px !important;
    align-self: center !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .v-toolbar .v-btn .v-btn__content {
    padding: 0 4px !important;
    align-items: center !important;
    justify-content: center !important;
  }

  /* Asegurar que el toolbar tenga altura correcta */
  .v-toolbar {
    min-height: 64px !important;
    align-items: center !important;
  }

  .v-toolbar_content {
    align-items: center !important;
    min-height: 64px !important;
  }

  /* Ocultar texto del botón en móvil muy pequeño */
  @media (max-width: 430px) {
    .v-toolbar .v-btn {
      min-width: 40px !important;
      width: 40px !important;
      height: 40px !important;
      padding: 0 !important;
    }

    .v-toolbar .v-btn .v-btn__content {
      padding: 0 !important;
    }

    /* Ocultar texto, mostrar solo icono */
    .v-toolbar .v-btn span {
      display: none !important;
    }
  }
}
</style>
